export function fetchCheckLogin() {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/auth/whoami`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }
  ).then((response) => response.json());
}

export function fetchLogin(loginCredential) {
  return fetch(`${process.env.REACT_APP_BASE_API}order-api/api/v1/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      email: loginCredential[0],
      password: loginCredential[1],
    }),
  })
  .then((response) => response.json())
  .then((data) => {
    // console.log('Login Response:', data); // Log response
    return data;
  });
}

export function fetchForgotPassword(email) {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/forgotPasswordAccount.php?action=send_otp&email=${encodeURIComponent(email)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }
  ).then((response) => response.json());
}

export function fetchRegister(registerCredential) {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/registerAccount.php`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        firstname: registerCredential.firstname,
        lastname: registerCredential.lastname,
        email: registerCredential.email,
        address1: registerCredential.address1,
        address2: registerCredential.address2,
        city: registerCredential.city,
        state: registerCredential.state,
        postcode: registerCredential.postcode,
        country: registerCredential.country,
        phonenumber: registerCredential.phonenumber,
        password: registerCredential.password,
        password2: registerCredential.password2,
        company: registerCredential.company
      }),
    }
  ).then((response) => response.json());
}
